import {
  FileTextOutlined,
  LinkOutlined,
  VideoCameraOutlined,
  PlaySquareOutlined,
  CheckCircleFilled,
  PlayCircleOutlined,
  LoadingOutlined,
  LockOutlined,
} from "@ant-design/icons";
import {
  ObjectiveType,
  ObjectiveCompletionStatus,
} from "../../../types/client-education-detail.types";
import type { ObjectiveDto } from "../../../types/client-education-detail.types";
import styles from "./ContentSection.module.scss";

function typeIcon(objective: ObjectiveDto) {
  if (objective.type === ObjectiveType.LINK) return <LinkOutlined />;
  if (objective.type === ObjectiveType.JITSI) return <VideoCameraOutlined />;
  // Yüklenen dosya video ise belge ikonu yanıltıcıydı: video içerik listede
  // PDF/belge gibi görünüyordu.
  if (objective.file?.mimeType?.startsWith("video")) return <PlaySquareOutlined />;
  return <FileTextOutlined />;
}

/**
 * Video süresi saniyeden dakikaya çevrilerek geliyor ve ondalıklı olabiliyor
 * (ör. 2.079733933333333). Tek ondalığa yuvarlayıp Türkçe biçimde gösteriyoruz.
 */
function formatDurationMinutes(minutes: number): string {
  return minutes.toLocaleString("tr-TR", { maximumFractionDigits: 1 });
}

function statusEl(s?: ObjectiveCompletionStatus) {
  if (s === ObjectiveCompletionStatus.COMPLETED)
    return <span className={styles.done}><CheckCircleFilled /></span>;
  if (s === ObjectiveCompletionStatus.IN_PROGRESS)
    return <span className={styles.inProg}><LoadingOutlined /></span>;
  return <span className={styles.notStarted}><PlayCircleOutlined /></span>;
}

export function ObjectiveRow(props: {
  objective: ObjectiveDto;
  active: boolean;
  onSelect: () => void;
}) {
  const { objective, active, onSelect } = props;
  const durationMin =
    objective.durationMinutes ?? objective.file?.durationMinutes ?? null;
  const isVideo =
    objective.type === ObjectiveType.INTERNAL_FILE &&
    (objective.file?.mimeType?.startsWith("video") ?? false);
  const isLocked = isVideo && objective.isLocked;
  return (
    <button
      type="button"
      onClick={onSelect}
      disabled={isLocked}
      title={isLocked ? "Önce bir önceki videoyu tamamlamalısınız" : undefined}
      className={`${styles.objRow} ${active ? styles.objRowActive : ""} ${
        isLocked ? styles.objRowLocked : ""
      }`}
    >
      <span className={styles.objIcon}>{typeIcon(objective)}</span>
      <span className={styles.objTitle}>{objective.title}</span>
      {durationMin != null && (
        <span className={styles.objDuration}>
          {formatDurationMinutes(durationMin)} dk
        </span>
      )}
      <span className={styles.objStatus}>
        {isLocked ? <LockOutlined /> : statusEl(objective.completionStatus ?? objective.status)}
      </span>
    </button>
  );
}
